export const SET_LOGIN_DETAILS = "SET_LOGIN_DETAILS";
export const RESET_APP = "RESET_APP";
